import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/svg/bed-double.svg")